import {Card} from "./Card";

var template = require('./AttestationCard.twig');

export class AttestationCard extends Card
{
    constructor() {
        super();

        const isAllergan = app.appData.companyKey.includes("allergan");

        let twigData = app.appData.layout.meeting_request;

        if (isAllergan) {
            const opcoCode = app.appData.curPosition.opco_code;
            const pharmaOpcos = app.appData.configs.PHARMA_OPCOS || [];

            this.is_pharma_opco = pharmaOpcos.includes(opcoCode);

            twigData = {
                ...twigData,
                is_pharma_opco: this.is_pharma_opco
            };
        }

        this.program_details_confirmed = null;

        this.dom = $(twig({data: template}).render(twigData));

        this.dom.find('input[type=checkbox], input[type=radio]').on('click change', () => {
            let checked = this.dom.find('input[name="program_details_confirmed"]:checked');
            this.program_details_confirmed = checked.length ? checked.val() : null;
            this.cardFilledOutTriggers();
        });
    }

    isFilledOut() {
        let filled_out = true;
        this.dom.find('#attestation').removeClass("is-invalid");

        if(!this.dom.find('#attestation').is(':checked')) {
            filled_out = false;
            this.dom.find('#attestation').addClass("is-invalid");
        }

        if (this.is_pharma_opco === false) {
            let radios = this.dom.find('input[name="program_details_confirmed"]');
            radios.removeClass("is-invalid");

            if (!this.dom.find('input[name="program_details_confirmed"]:checked').length) {
                filled_out = false;
                radios.addClass("is-invalid");
            }
        }

        return filled_out;
    }

    clear() {
        super.clear();
        this.program_details_confirmed = null;
    }

    getProgramDetailsConfirmed() {
        if (!this.dom.is(':visible') || this.is_pharma_opco !== false) {
            return null;
        }

        return this.program_details_confirmed;
    }

}
